module.exports = __webpack_public_path__ + "img/ge.8210444e.svg";